import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/site";

export const QuoteSuccess = ({ reference, name, confirmationTo, onReset }) => (
  <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
    className="rounded-[1.5rem] bg-[var(--green-tint)] p-8 sm:p-12" data-testid="quote-form-success-confirmation" role="status">
    <motion.span initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.2, type: "spring", stiffness: 260, damping: 18 }} className="inline-block">
      <CheckCircle2 className="h-14 w-14 text-[var(--green)]" />
    </motion.span>
    <h2 className="mt-6 font-display text-3xl sm:text-4xl font-bold tracking-tight text-[var(--navy)]">Thank you{name ? `, ${name}` : ""}!</h2>
    <p className="mt-4 max-w-lg text-lg text-[var(--ink)] leading-relaxed">
      Your free quote request has been sent to Easy Handyman Services. We'll be in touch soon to discuss your job.
    </p>
    {reference && <p className="mt-4 text-sm text-slate-700">Your reference: <strong data-testid="quote-reference">{reference}</strong></p>}
    {confirmationTo && <p className="mt-2 text-sm text-slate-700" data-testid="quote-confirmation-note">We've also sent a confirmation to <strong className="break-all">{confirmationTo}</strong>.</p>}
    <p className="mt-6 text-sm text-slate-700">Need us sooner? Call <a href={PHONE_TEL} className="font-semibold underline">{PHONE_DISPLAY}</a>.</p>
    <button type="button" onClick={onReset} data-testid="quote-form-new-request" className="mt-8 rounded-full border border-[var(--navy)] px-6 py-3 font-semibold text-[var(--navy)] hover:bg-[var(--navy)] hover:text-white transition-colors">
      Send another request
    </button>
  </motion.div>
);
